<div
	class="absolute cursor-pointer top-8 right-8"
	(click)="closeModalPanel()"
	[ngClass]="customStyles()"
>
	<uc-close-modal-svg></uc-close-modal-svg>
</div>
